import React, { useState, useEffect } from 'react';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';

// Adapted from React-Select documentation: https://react-select.com/creatable
const CreatableInputOnly = ({
  onChange,
  validate,
  value = [],
  ...selectProps
}) => {
  const [values, setValues] = useState({
    inputValue: '',
    selectedValues: value,
  });

  const { selectedValues, inputValue } = values;

  const createOption = (newValue) => (
    { label: newValue, value: newValue }
  );

  useEffect(() => {
    if (onChange) {
      onChange(selectedValues);
    }
  }, [selectedValues]);

  useEffect(() => {
    setValues({ inputValue: '', selectedValues: value });
  }, [value]);

  const components = { DropdownIndicator: null };

  const handleChange = (newValue) => {
    setValues({ ...values, selectedValues: newValue });
  };

  const styles = {
    container: (provided) => ({
      ...provided,
      padding: 0,
      height: 'fit-content',
      zIndex: 4,
      color: '#000',
      fontSize: '.875rem',
    }),
    control: (provided) => ({
      ...provided,
      borderWidth: 0,
      minHeight: 'fit-content',
      height: 'fit-content',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '31px !important',
    }),
    input: (provided) => ({
      ...provided,
      height: '21px !important',
      padding: 0,
    }),
    multiValue: (base) => ({
      ...base,
      padding: 0,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const onInputChange = (newValue) => {
    // function not declared or validation returns True
    if (!newValue || !validate || validate(newValue)) {
      setValues((prevState) => ({
        ...prevState,
        inputValue: newValue,
      })); // all conditions met, set input value
    }
  };

  const onKeyDown = (event) => {
    const alreadyEntered = selectedValues?.find(({
      label,
      value: optionValue,
    }) => label === inputValue && optionValue === inputValue);

    switch (event.key) {
      case ' ':
      case 'Tab':
        event.preventDefault();
        if (inputValue && !alreadyEntered) {
          setValues({
            inputValue: '',
            selectedValues: [
              ...selectedValues,
              createOption(inputValue),
            ],
          });
        }
        break;
      default:
    }
  };

  return (
    <CreatableSelect
      {...selectProps}
      value={value}
      components={components}
      inputValue={values.inputValue}
      styles={styles}
      isClearable
      isMulti
      menuIsOpen={false}
      onChange={handleChange}
      onInputChange={onInputChange}
      onKeyDown={onKeyDown}
    />
  );
};

CreatableInputOnly.propTypes = {
  onChange: PropTypes.func,
  validate: PropTypes.func,
  value: PropTypes.arrayOf(),

};

CreatableInputOnly.defaultProps = {
  onChange: undefined,
  validate: undefined,
  value: undefined,
};

export default CreatableInputOnly;
